module.exports = __webpack_public_path__ + "img/game_logo3.720e08d1.png";